import api from '../services/api';
import { createBaseModule } from './base';
import router from '@/router'

export default createBaseModule( {
  state: {
    products: [],
    section_id: false,
    section: {},
    product_total: 0,
    noMoreProducts: false,
    lastFetchProductsKey: null
  },
  mutations: {
    SET_DATA(state, {products, page}) {

      if (page > 1) {
        state.products = state.products.concat(products.data.items)
      }
      else
        state.products = products.data.items;
      if (state.products.length >= products.data.total)
        state.noMoreProducts = true;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
      state.section = products.data.section;
      state.product_total = products.data.total;
    },
    SET_LAST_FETCH_PRODUCTS_KEY(state, key) {
      state.lastFetchProductsKey = key;
    },
  },
  actions: {
    async fetchProducts({ commit, state }, {id, page, sort, filter={}, search='', first=false, page_size=false, withoutpage= false}) {

      if (id == undefined)
        return;

      // Нормализуем filter (порядок ключей/элементов не влияет) и собираем "сигнатуру" запроса
      const stableSerialize = (value) => {
        if (Array.isArray(value)) {
          // Если в массиве объекты — сортируем по их стабильной сериализации
          return value
              .map(stableSerialize)
              .sort();
        }
        if (value && typeof value === 'object') {
          const keys = Object.keys(value).sort();
          const out = {};
          for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            out[k] = stableSerialize(value[k]);
          }
          return out;
        }
        return value;
      };

      const requestKey = JSON.stringify({
        id: id,
        //page: page,
        page_size: page_size,
        sort: sort,
        q: search,
        filter: stableSerialize(filter)
      });

      // Если повторный вызов с теми же параметрами — ничего не делаем
      if (state.products.length > 0 && state.lastFetchProductsKey === requestKey && first) {
        return;
      }

      state.section_id = id;

      if (page == 1) {
        commit('RESET_STATE');
        state.noMoreProducts = false;
      }

      let params = {
        page: page
      };
      if (filter)
        params.filter = filter;
      if (page_size)
        params.page_size = page_size;
      if (sort)
        params.sort = sort;
      if (search)
        params.q = search;
      if (filter) {
        params.filter = filter;
        params.set_filter = 'Y';
      }
      if (withoutpage)
        params.withoutpage = withoutpage;
      /*{
        page: page,
            filter: filter,
          sort: sort,
          q: search
      }*/

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/catalog/elements/'+id+'/', {
          params: params
        });
        if (response?.data?.data?.items) {
          commit('SET_DATA', {products: response.data, page: page});
          commit('SET_ERROR', null);
        }
        else {
          if (response?.data?.errors && Array.isArray(response.data.errors)) {
            // Проверяем есть ли в массиве ошибки с числовым кодом или code_error
            const hasTechnicalError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'code_error'
            );

            const hasNotFoundError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'not_found'
            );

            if (hasTechnicalError) {
              commit('SET_ERROR', 'Техническая ошибка');
            } else  if (hasNotFoundError) {
              router.push("/404/");
            } else {
              const errorMessages = response.data.errors
                  .map(error => error.message)
                  .join('. ');

              commit('SET_ERROR', errorMessages);
            }
          } else {
            commit('SET_ERROR', 'Произошла ошибка при выполнении операции');
          }


        }

      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    products: state => state.products,
    productsLoading: state => state.loading,
    productsError: state => state.error,
    productsLoaded: state => state.loaded,
    product_total: state => state.product_total,
    section: state => state.section,
    section_id: state => state.section_id,
    noMoreProducts: state => state.noMoreProducts
  }
})